import * as React from 'react';

export class NotFoundSvg extends React.Component<{}> {

  render() {
    return (
      <svg id="404-not-found-svg" width="426" height="138" viewBox="0 0 426 138" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M350 88H425V76H350V88Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M350 88H425V75H350V88ZM350.625 87.35H424.375V75.65H350.625V87.35Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M350 138H425V75H350V138ZM351.25 136.74H423.75V76.26H351.25V136.74Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M387.388 130H388V129.364H387.388V130Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M0 13H75V1H0V13Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13H75V0H0V13ZM0.625 12.35H74.375V0.65H0.625V12.35Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 63H75V0H0V63ZM1.25 61.74H73.75V1.26H1.25V61.74Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M87.8982 12.2318H249.931V0.313629H87.8982V12.2318Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 12.5455H250.244V0H87.5854V12.5455ZM88.2111 11.9182H249.618V0.627273H88.2111V11.9182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 62.7273H250.244V0H87.5854V62.7273ZM88.8367 61.4727H248.993V1.25455H88.8367V61.4727Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M96.9695 38.2636H240.86V37.0091H96.9695V38.2636Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M192.896 53.9455C205.246 53.9455 211.407 45.8311 217.375 38.0177C223.385 30.1492 229.2 22.5818 240.86 22.5818V21.3273C228.51 21.3273
          222.349 29.4417 216.381 37.255C210.372 45.1235 204.556 52.6909 192.896 52.6909V53.9455ZM144.933 22.5818C156.565 22.5818 162.38 30.1486
          168.397 38.0181C174.372 45.8314 180.547 53.9455 192.896 53.9455V52.6909C181.236 52.6909 175.407 45.1232 169.39 37.2547C163.417 29.4423
          157.255 21.3273 144.933 21.3273V22.5818ZM96.9695 53.9455C109.291 53.9455 115.453 45.8304 121.427 38.0181C127.443 30.1495 133.273 22.5818
          144.933 22.5818V21.3273C132.584 21.3273 126.408 29.4414 120.434 37.2547C114.417 45.1241 108.601 52.6909 96.9695 52.6909V53.9455Z"
          fill="white"
        />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.89 127.964C139.061 127.964 135.132 124.024 135.132 119.182C135.132 114.34 139.061 110.4 143.89 110.4C148.72 110.4 152.649 114.34
          152.649 119.182C152.649 124.024 148.72 127.964 143.89 127.964Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.89 109.773C138.708 109.773 134.506 113.985 134.506 119.182C134.506 124.378 138.708 128.591 143.89 128.591C149.073 128.591 153.274
          124.378 153.274 119.182C153.274 113.985 149.073 109.773 143.89 109.773ZM143.89 111.027C148.375 111.027 152.023 114.686 152.023
          119.182C152.023 123.678 148.375 127.336 143.89 127.336C139.406 127.336 135.757 123.678 135.757 119.182C135.757 114.686 139.406 111.027
          143.89 111.027Z"
          fill="white"
        />
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M87.8982 87.5045H162.346V75.5864H87.8982V87.5045Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 87.8182H162.659V75.2727H87.5854V87.8182ZM88.2111 87.1909H162.033V75.9H88.2111V87.1909Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 138H162.659V75.2727H87.5854V138ZM88.8367 136.745H161.407V76.5273H88.8367V136.745Z"
          fill="white"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.61 127.964C104.331 127.964 97.5952 121.21 97.5952 112.909C97.5952 104.608 104.331 97.8546 112.61 97.8546C120.889 97.8546 127.624
          104.608 127.624 112.909C127.624 121.21 120.889 127.964 112.61 127.964Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.61 97.2273C103.972 97.2273 96.9695 104.248 96.9695 112.909C96.9695 121.57 103.972 128.591 112.61 128.591C121.248 128.591 128.25
          121.57 128.25 112.909C128.25 104.248 121.248 97.2273 112.61 97.2273ZM112.61 98.4818C120.544 98.4818 126.999 104.954 126.999 112.909C126.999
          120.864 120.544 127.336 112.61 127.336C104.676 127.336 98.2207 120.864 98.2207 112.909C98.2207 104.954 104.676 98.4818 112.61 98.4818Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M132.629 97.2273C125.719 97.2273 120.117 102.844 120.117 109.773C120.117 116.702 125.719 122.318 132.629 122.318C139.54 122.318
          145.142 116.702 145.142 109.773C145.142 102.844 139.54 97.2273 132.629 97.2273ZM132.629 98.4818C138.839 98.4818 143.89 103.547 143.89
          109.773C143.89 115.999 138.839 121.064 132.629 121.064C126.42 121.064 121.368 115.999 121.368 109.773C121.368 103.547 126.42 98.4818
          132.629 98.4818Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M283.152 53.3182H284.403V40.7727H283.152V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M272.14 53.3182H273.391V34.5H272.14V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M294.161 53.3182H295.412V28.2273H294.161V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M305.173 53.3182H306.424V34.5H305.173V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M316.182 53.3182H317.433V40.7727H316.182V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M327.194 53.3182H328.445V21.9545H327.194V53.3182Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M263.069 12.2318H337.516V0.313629H263.069V12.2318Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M262.756 12.5455H337.829V0H262.756V12.5455ZM263.382 11.9182H337.204V0.627273H263.382V11.9182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M262.756 62.7273H337.829V0H262.756V62.7273ZM264.007 61.4727H336.578V1.25455H264.007V61.4727Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M372.238 25.7182H378.494V24.4636H372.238V25.7182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M372.238 38.2636H378.494V37.0091H372.238V38.2636Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M372.238 50.8091H378.494V49.5545H372.238V50.8091Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M350.654 12.2318H425.102V0.313629H350.654V12.2318Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.342 12.5455H425.415V0H350.342V12.5455ZM350.967 11.9182H424.789V0.627273H350.967V11.9182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.342 62.7273H425.415V0H350.342V62.7273ZM351.593 61.4727H424.164V1.25455H351.593V61.4727Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M400.39 21.9545C391.752 21.9545 384.75 28.9756 384.75 37.6364C384.75 46.2971 391.752 53.3182 400.39 53.3182C409.028 53.3182 416.03
          46.2971 416.03 37.6364C416.03 28.9756 409.028 21.9545 400.39 21.9545ZM400.39 23.2091C408.324 23.2091 414.779 29.6813 414.779
          37.6364C414.779 45.5914 408.324 52.0636 400.39 52.0636C392.456 52.0636 386.001 45.5914 386.001 37.6364C386.001 29.6813 392.456
          23.2091 400.39 23.2091Z"
          fill="white"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M401.016 38.2636H415.392C415.071 46.0666 408.798 52.3566 401.016 52.6781V38.2636Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M416.03 37.6364H400.39V53.3182C409.028 53.3182 416.03 46.2971 416.03
          37.6364ZM414.725 38.8909C414.125 45.848 408.58 51.4078 401.641 52.0097V38.8909H414.725Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 27.6C361.474 27.6 360.351 26.4744 360.351 25.0909C360.351 23.7075 361.474 22.5818 362.854 22.5818C364.234 22.5818 365.356
          23.7075 365.356 25.0909C365.356 26.4744 364.234 27.6 362.854 27.6Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 21.9545C361.126 21.9545 359.726 23.359 359.726 25.0909C359.726 26.8228 361.126 28.2273 362.854 28.2273C364.581 28.2273 365.982
          26.8228 365.982 25.0909C365.982 23.359 364.581 21.9545 362.854 21.9545ZM362.854 23.2091C363.889 23.2091 364.73 24.0531 364.73
          25.0909C364.73 26.1287 363.889 26.9727 362.854 26.9727C361.819 26.9727 360.977 26.1287 360.977 25.0909C360.977 24.0531 361.819 23.2091
          362.854 23.2091Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 40.1455C361.474 40.1455 360.351 39.0198 360.351 37.6364C360.351 36.2529 361.474 35.1273 362.854 35.1273C364.234 35.1273 365.356
          36.2529 365.356 37.6364C365.356 39.0198 364.234 40.1455 362.854 40.1455Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 34.5C361.126 34.5 359.726 35.9045 359.726 37.6364C359.726 39.3683 361.126 40.7727 362.854 40.7727C364.581 40.7727 365.982
          39.3683 365.982 37.6364C365.982 35.9045 364.581 34.5 362.854 34.5ZM362.854 35.7545C363.889 35.7545 364.73 36.5985 364.73 37.6364C364.73
          38.6742 363.889 39.5182 362.854 39.5182C361.819 39.5182 360.977 38.6742 360.977 37.6364C360.977 36.5985 361.819 35.7545 362.854 35.7545Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 52.6909C361.474 52.6909 360.351 51.5653 360.351 50.1818C360.351 48.7984 361.474 47.6727 362.854 47.6727C364.234 47.6727 365.356
          48.7984 365.356 50.1818C365.356 51.5653 364.234 52.6909 362.854 52.6909Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 47.0455C361.126 47.0455 359.726 48.4499 359.726 50.1818C359.726 51.9137 361.126 53.3182 362.854 53.3182C364.581 53.3182 365.982
          51.9137 365.982 50.1818C365.982 48.4499 364.581 47.0455 362.854 47.0455ZM362.854 48.3C363.889 48.3 364.73 49.144 364.73 50.1818C364.73
          51.2197 363.889 52.0637 362.854 52.0637C361.819 52.0637 360.977 51.2197 360.977 50.1818C360.977 49.144 361.819 48.3 362.854 48.3Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M21.8962 100.991H28.1523V99.7364H21.8962V100.991Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M21.8962 113.536H28.1523V112.282H21.8962V113.536Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M21.8962 126.082H28.1523V124.827H21.8962V126.082Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M0.312744 87.5045H74.7603V75.5864H0.312744V87.5045Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 87.8182H75.0732V75.2727H0V87.8182ZM0.62561 87.1909H74.4476V75.9H0.62561V87.1909Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 138H75.0732V75.2727H0V138ZM1.25122 136.745H73.822V76.5273H1.25122V136.745Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.0487 97.2273C41.4109 97.2273 34.4084 104.248 34.4084 112.909C34.4084 121.57 41.4109 128.591 50.0487 128.591C58.6865 128.591 65.6889
          121.57 65.6889 112.909C65.6889 104.248 58.6865 97.2273 50.0487 97.2273ZM50.0487 98.4818C57.9827 98.4818 64.4377 104.954 64.4377
          112.909C64.4377 120.864 57.9827 127.336 50.0487 127.336C42.1147 127.336 35.6597 120.864 35.6597 112.909C35.6597 104.954 42.1147
          98.4818 50.0487 98.4818Z"
          fill="white"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.6743 113.536H65.0505C64.7299 121.339 58.4566 127.629 50.6743 127.951V113.536Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.6891 112.909H50.0488V128.591C58.6866 128.591 65.6891 121.57 65.6891 112.909ZM64.3841 114.164C63.7838 121.121 58.2387 126.681 51.3
          127.282V114.164H64.3841Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5122 102.873C11.1324 102.873 10.0098 101.747 10.0098 100.364C10.0098 98.9802 11.1324 97.8546 12.5122 97.8546C13.892 97.8546 15.0146
          98.9802 15.0146 100.364C15.0146 101.747 13.892 102.873 12.5122 102.873Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5121 97.2273C10.7845 97.2273 9.38403 98.6317 9.38403 100.364C9.38403 102.096 10.7845 103.5 12.5121 103.5C14.2397 103.5 15.6401
          102.096 15.6401 100.364C15.6401 98.6317 14.2397 97.2273 12.5121 97.2273ZM12.5121 98.4818C13.5472 98.4818 14.3889 99.3258 14.3889
          100.364C14.3889 101.401 13.5472 102.245 12.5121 102.245C11.477 102.245 10.6353 101.401 10.6353 100.364C10.6353 99.3258 11.477 98.4818
          12.5121 98.4818Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5122 115.418C11.1324 115.418 10.0098 114.293 10.0098 112.909C10.0098 111.526 11.1324 110.4 12.5122 110.4C13.892 110.4 15.0146
          111.526 15.0146 112.909C15.0146 114.293 13.892 115.418 12.5122 115.418Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5121 109.773C10.7845 109.773 9.38403 111.177 9.38403 112.909C9.38403 114.641 10.7845 116.045 12.5121 116.045C14.2397 116.045 15.6401
          114.641 15.6401 112.909C15.6401 111.177 14.2397 109.773 12.5121 109.773ZM12.5121 111.027C13.5472 111.027 14.3889 111.871 14.3889
          112.909C14.3889 113.947 13.5472 114.791 12.5121 114.791C11.477 114.791 10.6353 113.947 10.6353 112.909C10.6353 111.871 11.477 111.027
          12.5121 111.027Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5122 127.964C11.1324 127.964 10.0098 126.838 10.0098 125.455C10.0098 124.071 11.1324 122.945 12.5122 122.945C13.892 122.945 15.0146
          124.071 15.0146 125.455C15.0146 126.838 13.892 127.964 12.5122 127.964Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5121 122.318C10.7845 122.318 9.38403 123.723 9.38403 125.455C9.38403 127.186 10.7845 128.591 12.5121 128.591C14.2397 128.591 15.6401
          127.186 15.6401 125.455C15.6401 123.723 14.2397 122.318 12.5121 122.318ZM12.5121 123.573C13.5472 123.573 14.3889 124.417 14.3889
          125.455C14.3889 126.492 13.5472 127.336 12.5121 127.336C11.477 127.336 10.6353 126.492 10.6353 125.455C10.6353 124.417 11.477 123.573
          12.5121 123.573Z"
          fill="white"
        />
        <g opacity="0.8">
          <path
            d="M229.316 121.03H218.689V136.761H214.725V121.03H183.011V118.205L213.586 74.767H218.689V117.403H229.316V121.03ZM214.725
            117.403V99.7753C214.725 91.2846 214.921 84.1574 215.315 78.3938H214.978C214.415 79.4341 212.686 82.0769 209.79 86.3223L188.029
            117.403H214.725Z"
            fill="white"
          />
          <path
            d="M275.031 105.764C275.031 116.588 273.373 124.601 270.055 129.802C266.766 135.004 261.775 137.604 255.084 137.604C248.645 137.604
            243.753 134.933 240.408 129.591C237.062 124.221 235.389 116.279 235.389 105.764C235.389 95.0239 237.006 87.0673 240.239 81.8942C243.5
            76.721 248.449 74.1344 255.084 74.1344C261.578 74.1344 266.527 76.8194 269.928 82.1894C273.33 87.5312 275.031 95.3894 275.031
            105.764ZM239.944 105.764C239.944 115.323 241.195 122.394 243.697 126.977C246.199 131.531 249.995 133.809 255.084 133.809C260.397
            133.809 264.263 131.447 266.681 126.724C269.127 122 270.35 115.014 270.35 105.764C270.35 96.6546 269.127 89.7383 266.681
            85.0149C264.263 80.2916 260.397 77.9299 255.084 77.9299C249.77 77.9299 245.918 80.2916 243.528 85.0149C241.139 89.7383 239.944
            96.6546 239.944 105.764Z"
            fill="white"
          />
          <path
            d="M328 121.03H317.373V136.761H313.408V121.03H281.695V118.205L312.27 74.767H317.373V117.403H328V121.03ZM313.408 117.403V99.7753C313.408
            91.2846 313.605 84.1574 313.999 78.3938H313.661C313.099 79.4341 311.37 82.0769 308.474 86.3223L286.713 117.403H313.408Z"
            fill="white"
          />
        </g>
        <path opacity="0.5" d="M9 33H24V54H9V33Z" fill="white"/>
        <path opacity="0.5" d="M37 21H53V54H37V21Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M23 34H10V53H23V34ZM9 33V54H24V33H9Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M37 41H24V53H37V41ZM23 40V54H38V40H23Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M52 22H38V53H52V22ZM37 21V54H53V21H37Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M66 28H53V53H66V28ZM52 27V54H67V27H52Z" fill="white"/>
        <path opacity="0.5" d="M359 109H374V130H359V109Z" fill="white"/>
        <path opacity="0.5" d="M387 97H403V130H387V97Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M373 110H360V129H373V110ZM359 109V130H374V109H359Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M387 117H374V129H387V117ZM373 116V130H388V116H373Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M402 98H388V129H402V98ZM387 97V130H403V97H387Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M416 104H403V129H416V104ZM402 103V130H417V103H402Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M74 13H0V12H74V13Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M250 13H88V12H250V13Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M74 88H0V87H74V88Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M162 88H88V87H162V88Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M337 13H263V12H337V13Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M425 88H351V87H425V88Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M425 13H351V12H425V13Z" fill="white"/>
      </svg>

    )
  }
}